import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Grid } from '@mui/material';
import PortsCard from 'modules/yards/cards/PortsCard';
import usePorts from 'modules/yards/hooks/usePorts';


const YardsInner = () => {
    const {t} = useTranslation();
    const { loadingPorts, destinationPorts } = usePorts();

    return (
        <Container maxWidth="lg" sx={{mt: 2}}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <PortsCard
                        title={t('loading_ports')}
                        ports={loadingPorts}
                        isLoading
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <PortsCard
                        title={t('destination_ports')}
                        ports={destinationPorts}
                    />
                </Grid>
            </Grid>
        </Container>
    );
};

const Yards = () => {
    return (
        <Suspense fallback={null}>
            <YardsInner />
        </Suspense>
    )
}

export default Yards;
